<p-breadcrumb
  [styleClass]="'measured-breadcrumb'"
  [model]="items"
  [home]="home"></p-breadcrumb>
